var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetalive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 44,
    viewBox: "0 0 69 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.3027 37.7671H24.7969V43.6158H23.1006V37.7671H20.6084V36.3956H27.3027V37.7671Z",
    fill: "#282727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14187 39.5374L0 36.0668V43.6158H1.6963V39.4803L4.14187 41.5296L6.58824 39.4803V43.6158H8.28454V36.0668L4.14187 39.5374Z",
    fill: "#282727"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.1445 36.3956V43.6158H44.7544V42.2442H40.8264V36.3956H39.1445Z",
    fill: "#282727"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9277 36.3956V43.6158H47.2314V36.3956H48.9277Z",
    fill: "#282727"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2058 37.7671V36.3956H11.4375V43.6158H18.2058V42.2442H13.1338V40.6533H17.4549V39.3581H13.1338V37.7671H18.2058Z",
    fill: "#282727"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9999 37.7671V36.3956H62.2324V43.6158H68.9999V42.2442H63.9279V40.6533H68.2491V39.3581H63.9279V37.7671H68.9999Z",
    fill: "#282727"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3604 36.0668L28.0537 43.6158H30.0008L32.3604 39.4723L34.7199 43.6158H36.6671L32.3604 36.0668Z",
    fill: "#282727"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6368 43.9446L51.3301 36.3956H53.2764L55.6368 40.5391L57.9963 36.3956H59.9434L55.6368 43.9446Z",
    fill: "#282727"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8423 24.7965H43.7907L37.0771 13.1684L39.5259 8.92688L47.6384 22.9772H52.7916L39.5259 0L34.5005 8.70499L29.4743 0L12.582 29.2592H27.7876L33.4489 19.4528L30.8715 14.9901L25.2102 24.7965H20.3119L29.4743 8.92688L41.2133 29.2592H56.4189L53.8423 24.7965Z",
    fill: "url(#paint0_linear_8488_541)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8488_541",
    x1: 34.5005,
    y1: 28.9134,
    x2: 34.5005,
    y2: 0.278579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F1985"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3007F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetalive);
export default __webpack_public_path__ + "static/media/metalive.968fd73208a6f0ae6043dd3a1b43b3c2.svg";
export { ForwardRef as ReactComponent };